// Resolve only unset category links to sections that exist on the current page.
(() => {
  function connectSections() {
    document.querySelectorAll('a[data-section-target]').forEach(link => {
      if (link.getAttribute('href') !== '#') return;
      const prefix = link.dataset.sectionTarget;
      if (!prefix) return;
      const target = [...document.querySelectorAll('main section[id]')].find(section => section.id.startsWith(prefix));
      if (target) link.setAttribute('href', '#' + target.id);
    });
  }
  connectSections();
  document.addEventListener('shopify:section:load', connectSections);
})();
